import { Box } from '@mui/material';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
}

export function Logo({ size = 'medium' }: LogoProps) {
  return (
    <Box 
      component="img"
      src="/data/geography-data/chola-logo.png"
      alt="Chola MS General Insurance"
      sx={{
        height: size === 'small' ? '40px' : size === 'medium' ? '50px' : '60px',
        width: 'auto',
        objectFit: 'contain'
      }}
    />
  );
}